export default [
  {
    id: 1,
    class: 'header-row',
    title: 'Content',
    CityFALCON: {
      class: '',
      text: '',
    },
    Incumbents: {
      class: '',
      text: '',
    },
    WebScrapers: {
      class: '',
      text: '',
    },
  },
  {
    id: 2,
    class: '',
    title: 'Coverage of securities, topics, sectors, companies',
    CityFALCON: {
      class: 'green',
      text: 'High',
    },
    Incumbents: {
      class: 'green',
      text: 'High',
    },
    WebScrapers: {
      class: 'red',
      text: 'Low',
    },
  },
  {
    id: 3,
    class: '',
    title: 'Language Coverage',
    CityFALCON: {
      class: '',
      text: '30+',
    },
    Incumbents: {
      class: 'orange',
      text: 'Limited',
    },
    WebScrapers: {
      class: 'orange',
      text: 'Limited',
    },
  },
  {
    id: 4,
    class: '',
    title: 'Quality of insights and analysis of the data',
    CityFALCON: {
      class: 'green',
      text: 'High',
    },
    Incumbents: {
      class: 'red',
      text: 'Low',
    },
    WebScrapers: {
      class: 'red',
      text: 'No',
    },
  },
  {
    id: 5,
    class: '',
    title: 'Access to curated tweets and social media activity',
    CityFALCON: {
      class: 'green',
      text: 'Yes',
    },
    Incumbents: {
      class: 'red',
      text: 'No',
    },
    WebScrapers: {
      class: 'red',
      text: 'No',
    },
  },
  {
    id: 6,
    class: '',
    title: 'Access to paywalled and non-public content via Single Sign On',
    CityFALCON: {
      class: 'green',
      text: 'Yes',
    },
    Incumbents: {
      class: 'green',
      text: 'Yes',
    },
    WebScrapers: {
      class: 'red',
      text: 'No',
    },
  },
  {
    id: 7,
    class: '',
    title: 'No data deletion requirement after cancellation',
    CityFALCON: {
      class: 'green',
      text: 'Yes',
    },
    Incumbents: {
      class: 'red',
      text: 'No',
    },
    WebScrapers: {
      class: 'red',
      text: 'No',
    },
  },
  {
    id: 8,
    class: 'header-row',
    title: 'Curation & Customisation',
    CityFALCON: {
      class: '',
      text: '',
    },
    Incumbents: {
      class: '',
      text: '',
    },
    WebScrapers: {
      class: '',
      text: '',
    },
  },
  {
    id: 9,
    class: '',
    title: 'Filtration and customisation in the API',
    CityFALCON: {
      class: 'green',
      text: 'High',
    },
    Incumbents: {
      class: 'orange',
      text: 'Medium',
    },
    WebScrapers: {
      class: 'red',
      text: 'Low',
    },
  },
  {
    id: 10,
    class: '',
    title: 'Curation and Relevancy using NLP & ML',
    CityFALCON: {
      class: 'green',
      text: 'High',
    },
    Incumbents: {
      class: 'orange',
      text: 'Medium',
    },
    WebScrapers: {
      class: 'red',
      text: 'No',
    },
  },
  {
    id: 11,
    class: 'header-row',
    title: 'Legal',
    CityFALCON: {
      class: '',
      text: '',
    },
    Incumbents: {
      class: '',
      text: '',
    },
    WebScrapers: {
      class: '',
      text: '',
    },
  },
  {
    id: 12,
    class: '',
    title: 'Level of relationships with publications and content owners',
    CityFALCON: {
      class: 'green',
      text: 'High',
    },
    Incumbents: {
      class: 'green',
      text: 'High',
    },
    WebScrapers: {
      class: 'red',
      text: 'No',
    },
  },
  {
    id: 13,
    class: '',
    title: 'Copyright infringement protection',
    CityFALCON: {
      class: 'green',
      text: 'Yes',
    },
    Incumbents: {
      class: 'green',
      text: 'Yes',
    },
    WebScrapers: {
      class: 'red',
      text: 'No',
    },
  },
  {
    id: 14,
    class: 'header-row',
    title: 'Price',
    CityFALCON: {
      class: '',
      text: '',
    },
    Incumbents: {
      class: '',
      text: '',
    },
    WebScrapers: {
      class: '',
      text: '',
    },
  },
  {
    id: 15,
    class: '',
    title: 'Cost',
    CityFALCON: {
      class: '',
      text: 'Free / £',
    },
    Incumbents: {
      class: 'red',
      text: '£££',
    },
    WebScrapers: {
      class: 'green',
      text: '£',
    },
  },
];
